import React, { FC, useEffect, useContext, useMemo } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { useFetchUser } from '@shared/hooks';

import { authContext } from '@store/index';

import Header from './Header';
import LayoutMenu from './Menu';

const Layout: FC = () => {
  const [userData, fetchUser] = useFetchUser();
  const [authData] = useContext(authContext);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    fetchUser();
  }, []);

  // Получаем ключ из authData или из URL параметра (для мастер-кодов)
  const gameKey = useMemo(() => {
    const urlKey = searchParams.get('key');
    if (urlKey) return urlKey;

    // Для мастер-кодов проверяем masterKey
    const masterKey = (authData as any)?.masterKey?.key;
    if (masterKey) return masterKey;

    // Обычный ключ игры
    if (authData?.gameKey?.key) {
      return authData.gameKey.key;
    }

    // Для paywall режима - пытаемся восстановить резервный ключ из localStorage
    const art = searchParams.get('art');
    if (art) {
      try {
        // Мы находимся в роуте /constructor/:titleOrType, так что можем получить тип оттуда
        // Для других страниц (например /games/:type) мы не всегда знаем точное имя,
        // но там обычно и не нужен ключ в хедере.
        const pathParts = window.location.pathname.split('/');
        const titleOrType = pathParts[pathParts.length - 1];
        const safeGameName = (titleOrType || 'Memory').replace(/[^a-zA-Z0-9]/g, '_');
        
        const storageKey = `temp_paywall_${art}_${safeGameName}`;
        let stored = localStorage.getItem(storageKey);
        
        // Fallback на старый ключ для обратной совместимости
        if (!stored) {
          stored = localStorage.getItem(`temp_paywall_${art}`);
        }

        if (stored) {
          const parsed = JSON.parse(stored);
          return parsed.key;
        }
      } catch (e) {
        console.error('Failed to parse temp paywall key:', e);
      }
    }

    return undefined;
  }, [authData, searchParams]);

  return (
    <>
      <Header gameKey={gameKey} />
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default Layout;
